import React from "react";
import { ComplianceFormQuestion } from "../../../messages";
import { filterNestedQuestions } from "./complianceFormUtils";

interface Params {
  questions: ComplianceFormQuestion[];
  onLastStage: (questions: ComplianceFormQuestion[]) => void;
}

export type ComplianceFormQuestionState = ComplianceFormQuestion & {
  isHidden: boolean;
};

function useComplianceFormStage(params: Params) {
  const [questions, setQuestions] = React.useState(() => filterNestedQuestions(params.questions));
  const [currentQuestionIndex, setCurrentQuestionIndex] = React.useState(0);
  const currentQuestion = questions[currentQuestionIndex];

  const visibleQuestions = questions.filter((q) => !q.isHidden);
  const currentStageNumber = visibleQuestions.findIndex((q) => q.id === currentQuestion.id) + 1;
  const percentage = (currentStageNumber / visibleQuestions.length) * 100;
  const totalStages = visibleQuestions.length;

  const handleRequestPreviousStage = () => {
    let index;

    for (let i = currentQuestionIndex - 1; i >= 0; i--) {
      if (!questions[i].isHidden) {
        index = i;
        break;
      }
    }

    if (index !== undefined) {
      setCurrentQuestionIndex(index);
    }
  };

  const handleRequestNextStage = (questionWithAnswer: ComplianceFormQuestion) => {
    const newQuestions = filterNestedQuestions([
      ...questions.slice(0, currentQuestionIndex),
      questionWithAnswer,
      ...questions.slice(currentQuestionIndex + 1),
    ]);

    setQuestions(newQuestions);

    const currentIndex = newQuestions.findIndex((q) => q.id === questionWithAnswer.id);
    const index = newQuestions.findIndex((q, i) => !q.isHidden && i > currentIndex);

    if (index !== -1) {
      setCurrentQuestionIndex(index);
    } else {
      params.onLastStage(newQuestions.filter((q) => !q.isHidden));
    }
  };

  return {
    questions: questions,
    currentQuestion: currentQuestion,
    currentStageNumber: currentStageNumber,
    percentage: percentage,
    totalStages: totalStages,
    onRequestPreviousStage: handleRequestPreviousStage,
    onRequestNextStage: handleRequestNextStage,
  };
}

export default useComplianceFormStage;
